module.exports = __webpack_public_path__ + "static/media/6. Entre líneas1, Mixta en tela, 100 x 100 cm, 2019 copy.7c26238c.png";